import React from "react"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbParagraph from "../ui-kit/dfb_paragraph"
import Section from "./section"

const MCardGridSwitchMilestone = (props) => {
  return (
    <Section
      baseClass="m-CardGrid"
      defaultBgColor={"grey"}
      defaultPadding="large"
      data={props.data}
    >
      <div className="m-CardGrid-wrapper">
        <div className="m-CardGrid-container">
          <div className="c-Headline m-CardGrid-headline">
            <DfbHeadline
              headline={props.data.headline}
              headline_level="h3"
              add_class="c-Headline-strokeLine"
            />
          </div>
          {props.data.plaintext && (
            <DfbParagraph
              text={props.data.plaintext}
              add_class="m-CardGrid-paragraph"
            />
          )}
        </div>
        <div className="c-CardGrid c-CardGrid--milestones m-CardGrid-cards">
          <div className="c-CardGrid-container">
            {props.data.switch_milestone_item.map((item, index) => (
              <div className="c-CardGrid-card c-CardGrid-cardFour" key={index}>
                <div className="c-CardSwitch c-CardSwitch--milestone">
                  <DfbHeadline
                    headline={item.headline}
                    headline_level="h3"
                    add_class="c-CardSwitch-headline"
                  />
                  {item.subheadline && (
                    <DfbHeadline
                      headline={item.subheadline}
                      headline_level="h5"
                      add_class="c-CardSwitch-subline"
                    />
                  )}
                  <div className="c-CardSwitch-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path
                        fill="currentColor"
                        d="M12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm0 20c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9z"
                      />
                      <path
                        className="horizontally"
                        fill="currentColor"
                        d="M6 11h12v2H6z"
                      />
                      <path
                        className="vertically"
                        fill="currentColor"
                        d="M13 6v12h-2V6z"
                      />
                    </svg>
                  </div>
                  <div className="c-CardSwitch-overlay">
                    <DfbParagraph
                      text={item.plaintext}
                      add_class="c-CardSwitch-paragraph"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MCardGridSwitchMilestone
